// product.js
// Product related reducers

/****************************************************************
 * Imports
 ****************************************************************/
import * as Action from '../actions/product';
import dotProp from 'dot-prop-immutable';
import InitialState from '../data/InitialState';

/****************************************************************
 * Initial State
 ****************************************************************/
const productState = {
  ids: [],
  byId: {},
  nextId: 1,
}

/****************************************************************
 * Action Processors
 ****************************************************************/
// Processes PRODUCT_ADD
function addProduct (state, action) {
  var new_entry = {
    id: state.nextId,
    name: action.name,
    price: [
      { unit: "unidade", price: 1 }
    ],
  }

  var pos = state.ids.length;
  state = dotProp.set(state, `ids.${pos}`, new_entry.id);
  state = dotProp.set(state, `byId.${new_entry.id}`, new_entry);
  state = dotProp.set(state, 'nextId', state.nextId + 1);
  return state;
}

// Processes PRODUCT_REMOVE
function removeProduct (state, action) {
  state = dotProp.delete(state, `byId.${action.id}`);
  for(var i = state.ids.length - 1; i >= 0; i--) {
    if (state.ids[i] === action.id)
      return dotProp.delete(state, `ids.${i}`);
  }

  return state;
}

// Processes PRODUCT_RENAME
function renameProduct (state, action) {
  if (state.byId[action.id])
    return dotProp.set(state, `byId.${action.id}.name`, action.name);
  return state;
}

// Processes UNIT_ADD
function addUnit (state, action) {
  var product = state.byId[action.productId];
  if (!product) return state;

  var new_entry = { unit: action.name, price: 1 };

  var pos = product.price.length;
  return dotProp.set(state, `byId.${action.productId}.price.${pos}`, new_entry);
}

// Processes UNIT_REMOVE
function removeUnit (state, action) {
  var product = state.byId[action.productId];
  if (!product)
    return state;

  var nUnits =  product.price.length;
  if (nUnits === 1 || nUnits <= action.unitId)
    return state;

  return dotProp.delete(state, `byId.${action.productId}.price.${action.unitId}`);
}

// Processes UNIT_RENAME
function renameUnit (state, action) {
  var product = state.byId[action.productId];
  if (product == null || product.price.length <= action.unitId)
    return state;
  return dotProp.set(state, `byId.${action.productId}.price.${action.unitId}.unit`, action.name);
}

// Processes UNIT_SET_PRICE
function setUnitPrice (state, action) {
  var product = state.byId[action.productId];
  if (product == null || product.price.length <= action.unitId)
    return state;
    
  return dotProp.set(state, `byId.${action.productId}.price.${action.unitId}.price`, action.price);
}

/****************************************************************
 * Reducers
 ****************************************************************/
// List Reducer
export function productReducer (state, action) {
  if (state === undefined) {
    state = productState;
    InitialState.GetProducts().forEach((name) => {
      state = addProduct(state, Action.addProduct(name));
    });
  }

  switch (action.type) {
    case Action.PRODUCT_ADD:
      return addProduct(state, action);
    case Action.PRODUCT_REMOVE:
      return removeProduct(state, action);
    case Action.PRODUCT_RENAME:
      return renameProduct(state, action);
    case Action.UNIT_ADD:
      return addUnit(state, action);
    case Action.UNIT_REMOVE:
      return removeUnit(state, action);
    case Action.UNIT_RENAME:
      return renameUnit(state, action);
    case Action.UNIT_SET_PRICE:
      return setUnitPrice(state, action);
    default:
      return state;
  }
}

/****************************************************************
 * Exports
 ****************************************************************/
export default productReducer;



// WEBPACK FOOTER //
// ./src/reducers/product.js